import { generateSetChild } from '@/helpers/VuexHelpers'

export default {
	namespaced: true,
	state: {
		loading: false,
	},
	actions: {
		setLoading({commit, state}, loading = true) {
			commit('setLoading', {item: loading});
		},
	},
	getters: {
		isLoading(state) {
			return state.loading
		},
	},
	mutations: {
		setLoading: generateSetChild("loading"),
	}
}